import { RootState } from "../../../../../redux/store";

export const vehicleTypesLoading = (state: RootState) => state.vehicleTypes.itemsLoading;
export const vehicleTypesActionLoading = (state: RootState) => state.vehicleTypes.actionsLoading;
export const dropDownLoading = (state: RootState) => state.vehicleTypes.dropDownLoading;

export const vehicleTypes = (state: RootState) => state.vehicleTypes.items;
export const vehicleTypesCount = (state: RootState) => state.vehicleTypes.itemsCount;
export const vehicleTypeForEdit = (state: RootState) => state.vehicleTypes.itemForEdit;
export const getItemsSelect = (state: RootState) => state.vehicleTypes.dropDownItems;

export const error = (state: RootState) => state.vehicleTypes.error;
export const errorAction = (state: RootState) => state.vehicleTypes.errorAction;
export const dropDownError = (state: RootState) => state.vehicleTypes.dropDownError;

export const validationErrors = (state: RootState) => state.vehicleTypes.validationErrors;

export const filters = (state: RootState) => state.vehicleTypes.filters;
